export const SEARCH_PANEL_OFFSET_EVENT = 'header:update-search-offset';
